import React from 'react'
import Circle from 'app/components/SVGS/Circle'
import cn from 'classnames'

import UserAvatarForm from './UserAvatarForm'

import './styles.scss'
const bc = 'user-avatar'

const UserAvatarWithStats = ({
  avatar,
  circleProps,
  isUserBlock,
  isRecentFeed,
  isLeaderBoard,
  initials,
  proTrackProgress,
  streakCurrent,
  isProtrackPopup,
  isReactionPopup,
  isReactionBoard,
}) => {
  if (isUserBlock) {
    return (
      <div className={cn(bc, `${bc}__commit-details`)}>
        <Circle circleProps={circleProps} proTrackProgress={proTrackProgress} streakCurrent={streakCurrent} />
        <div className={`${bc}__image-holder`}>
          {avatar ? <img className={`${bc}__image`} src={avatar} alt={initials} /> : <UserAvatarForm />}
        </div>
      </div>
    )
  } else {
    return (
      <div
        className={cn(bc, {
          [`${bc}__leader-board`]: isLeaderBoard,
          [`${bc}__recent-feed`]: isRecentFeed,
          [`${bc}__protrack-popup`]: isProtrackPopup,
          [`${bc}__reaction-popup`]: isReactionPopup,
          [`${bc}__reaction-board`]: isReactionBoard,
        })}
      >
        <Circle circleProps={circleProps} proTrackProgress={proTrackProgress} streakCurrent={streakCurrent} />
        <div className={`${bc}__image-holder`}>
          {avatar ? (
            <img className={`${bc}__image`} src={avatar} alt={initials} />
          ) : (
            <div
              className={cn(`${bc}__initials`, {
                [`${bc}__initials--recent-feed`]: isRecentFeed,
                [`${bc}__initials--leader-board`]: isLeaderBoard,
                [`${bc}__initials--protrack-popup`]: isProtrackPopup,
                [`${bc}__initials--reaction-popup`]: isReactionPopup,
                [`${bc}__initials--reaction-board`]: isReactionBoard,
              })}
            >
              {initials}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default UserAvatarWithStats
